<div>
  @if (bannerText) {
    <div class="env-banner" [class.staging]="bannerText === 'STAGING'">
      {{ bannerText }}
    </div>
  }
  <router-outlet />
  <app-toast-host />
</div>
